import React from 'react'

const ThemeContext = React.createContext({
  isLightTheme: '',
  changeTheme: () => {},
  savedItems: [],
  changeSavedItems: () => {},
  deleteSavedItem: () => {},
})

export default ThemeContext
